import { render } from "./TeacherAssignments.vue?vue&type=template&id=40462c7e&scoped=true"
import script from "./TeacherAssignments.vue?vue&type=script&lang=js"
export * from "./TeacherAssignments.vue?vue&type=script&lang=js"

import "./TeacherAssignments.vue?vue&type=style&index=0&id=40462c7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40462c7e"]])

export default __exports__